var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "productimage-hero-modal",
      attrs: {
        top: "0",
        height: "100%",
        width: "100%",
        left: "0",
        name: "show-product-roomscene-view-hero-modal",
        "data-html2canvas-ignore": "true",
        adaptive: true,
        scrollable: true
      }
    },
    [
      _c("div", { staticClass: "productimage-hero-modal-wrapper" }, [
        _c("div", { staticClass: "productimage-hero-modal-close-btn" }, [
          _c(
            "button",
            {
              staticClass: "btn button-close",
              attrs: { type: "button" },
              on: { click: _vm.hideHeroModal }
            },
            [
              _c("span", {
                staticClass: "png-icon png-icon-icons-glyph--k-close",
                attrs: { "aria-label": "Close hero modal" }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "productimage-hero-modal-row" }, [
          _c(
            "div",
            { staticClass: "productimage-hero-modal-main-col" },
            [
              _vm.viewProductType === "swatch"
                ? [
                    _c(
                      "div",
                      { staticClass: "product-room-scene-viewer-warpper" },
                      [
                        _c(
                          "div",
                          { staticClass: "product-room-scene-viewer-box" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "product-room-scene-viewer-zoominout-col"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn button-plus shadow",
                                    class: {
                                      disabled:
                                        _vm.zoomLevel === _vm.maxZoomLevel
                                    },
                                    attrs: { type: "button" },
                                    on: { click: _vm.zoomIn }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "plus-sm-icon png-icon png-icon-icons-glyph--k-plus wf-product-refinement-list-header-toggle-inactive"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn button-minus shadow",
                                    class: {
                                      disabled:
                                        _vm.zoomLevel === _vm.minZoomLevel
                                    },
                                    attrs: { type: "button" },
                                    on: { click: _vm.zoomOut }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "plus-sm-icon png-icon png-icon-icons-glyph--k-minus wf-product-refinement-list-header-toggle-inactive"
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.hideSwatchMultiTileButtons.includes(
                              _vm.productData.productTypeDesc.toLowerCase()
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "product-room-scene-viewer-image-type-toggler"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "wf-product-room-scene-swatch border-0 shadow",
                                        class:
                                          _vm.isMultitile === false
                                            ? "font-weight-bold"
                                            : "color-light-grey",
                                        on: {
                                          click: function($event) {
                                            return _vm.imageTypeToggler(false)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "product.Details.Swatch.Label"
                                              ]
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "wf-product-room-scene-multiple border-0 shadow font-weight-bold",
                                        class:
                                          _vm.isMultitile === true
                                            ? "font-weight-bold"
                                            : "color-light-grey",
                                        on: {
                                          click: function($event) {
                                            return _vm.imageTypeToggler(true)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "product.Details.MultiTile.Label"
                                              ]
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "product-room-scene-viewer-swatch-image"
                              },
                              [
                                _c("img", {
                                  staticClass:
                                    "product-swatch-image-viewer swatch-zoomable",
                                  attrs: {
                                    src:
                                      _vm.isMultitile === true
                                        ? _vm.getInstallImgUrl(
                                            _vm.selectedInstallationMethod.name,
                                            2000
                                          )
                                        : _vm.$helpers.getColorThumbnailImageUrl(
                                            _vm.sellingStyleNumber,
                                            _vm.selectedColor.colorNumber,
                                            _vm.selectedProduct.productSizeImperial
                                              .toLowerCase()
                                              .replace(/ /g, "")
                                              .replace("x", "-")
                                              .replace(/[a-zA-Z]/g, "")
                                              .replace("-", "x"),
                                            _vm.productData.productTypeDesc
                                          ),
                                    alt: "img"
                                  },
                                  on: { error: _vm.handleThumbnailImageError }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.viewProductType === "roomscene"
                ? [
                    _c(
                      "div",
                      { staticClass: "product-room-scene-slider-view-wrap" },
                      [
                        _c(
                          "div",
                          { staticClass: "product-room-scene-slider-view" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "product-room-scene-slider-view-controls"
                              },
                              [
                                _vm.roomScenes.length > 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "product-room-scene-slider-view-controls-button"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn button-previous",
                                            attrs: { type: "button" },
                                            on: {
                                              click: _vm.setPreviousRoomScene
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "png-icon png-icon-icons-glyph--k-chevron-left",
                                              attrs: {
                                                "aria-label":
                                                  "Previous room scene"
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn button-next",
                                            attrs: { type: "button" },
                                            on: { click: _vm.setNextRoomScene }
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "png-icon png-icon-icons-glyph--k-chevron-right",
                                              attrs: {
                                                "aria-label": "Next room scene"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "product-room-scene-slider-view-controls-pagination"
                                  },
                                  [
                                    _c(
                                      "ul",
                                      _vm._l(_vm.roomScenes, function(
                                        roomScene,
                                        index
                                      ) {
                                        return _c(
                                          "li",
                                          { key: roomScene.data },
                                          [
                                            _c("button", {
                                              staticClass:
                                                "btn pagination-item-button",
                                              class:
                                                roomScene ===
                                                _vm.selectedRoomScene
                                                  ? "pagination-item-button-active"
                                                  : "",
                                              attrs: {
                                                type: "button",
                                                "aria-label":
                                                  "View room scene number " +
                                                  roomScene
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setPaginationIndex(
                                                    index
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "product-room-scene-slider-view-container"
                              },
                              [
                                _c("wf-load-image", {
                                  attrs: {
                                    "wrapper-class":
                                      "product-room-scene-slider-view-image-wrapper",
                                    "image-class":
                                      "product-room-scene-slider-view-image",
                                    id: "product-room-scene-slider-view-image",
                                    src: _vm.getRoomSceneImageUrl(
                                      _vm.selectedRoomScene,
                                      3000
                                    ),
                                    alt: "",
                                    "image-load": _vm.applyPanzoom
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.viewProductType === "360Video" && _vm.videoURL
                ? [
                    _c("div", { staticClass: "product-360-video-wrapper" }, [
                      _c(
                        "video",
                        {
                          staticClass: "rotation-video",
                          attrs: { controls: "", autoplay: "", loop: "" }
                        },
                        [
                          _c("source", {
                            attrs: { src: _vm.videoURL, type: "video/mp4" }
                          })
                        ]
                      )
                    ])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "productimage-hero-modal-aside-bar" }, [
            _vm.productData.productTypeDesc.toLowerCase() !=
            _vm.$resourceString[
              "productCategory.ResinousFlooring"
            ].toLowerCase()
              ? _c(
                  "div",
                  { staticClass: "productimage-hero-modal-install-methods" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-underline font-16 pb-3",
                        class: {
                          expanded: _vm.expandedFormGroup === "installMethod"
                        }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "installation-methods-label",
                            attrs: { for: "install-method-select" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.details.room.scene.installation.method"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formSelectedInstallationMethod,
                                expression: "formSelectedInstallationMethod"
                              }
                            ],
                            staticClass:
                              "border-0 cursor-pointer custom-dropdown text-uppercase",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.formSelectedInstallationMethod = $event
                                  .target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.installationMethods, function(
                            installationMethod
                          ) {
                            return _c(
                              "option",
                              {
                                key: installationMethod.code,
                                domProps: {
                                  value:
                                    installationMethod.tricycleCode ||
                                    installationMethod.code
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(installationMethod.name) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "productimage-hero-modal-color-list-wrap" },
              [
                _c(
                  "div",
                  { staticClass: "productimage-hero-modal-color-list" },
                  [
                    _c("pc-product-room-scene-colors", {
                      attrs: {
                        installationMethods: _vm.installationMethods,
                        product: _vm.product,
                        segments: _vm.segments,
                        segmentrooms: _vm.segmentrooms,
                        collectionsegments: _vm.collectionsegments,
                        roomscenenumbers: _vm.roomscenenumbers,
                        segmentRoomScenes: _vm.segmentRoomScenes,
                        mappedColors: _vm.mappedColors
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }